import React from 'react';

const InputDate = ({ label, register, errors, placeholder, validation }) => {
  // Fungsi untuk mendapatkan tanggal hari ini dalam format YYYY-MM-DD
  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  return (
    <div className="flex mb-4 w-full ">
      <div className="flex flex-col xl:flex-row justify-between items-start xl:items-center w-full">
        {label !== '' && (
          <label className="block font-medium mb-2 md:mb-0 h-[34px]">
            {label}
          </label>
        )}

        <input
          type="date"
          {...register(validation.name, validation.rules)}
          className={` px-1 md:px-3 mt-1 flex items-center h-[48px] border ${
            errors[validation.name] ? 'border-red' : 'border-borderGray'
          } rounded-md shadow-sm w-full xl:w-full`}
          placeholder={placeholder}
          defaultValue={getTodayDate()} // Menetapkan tanggal default hari ini
        />
      </div>
      {errors[validation.name] && (
        <p className="text-red text-right mt-2">
          {errors[validation.name].message}
        </p>
      )}
    </div>
  );
};

export default InputDate;
